module.exports = __webpack_public_path__ + "img/game4.a4fa146f.png";